export default __webpack_public_path__ + "static/media/close-square.e2bc4456.svg";